import { render, staticRenderFns } from "./WelcomeSecondScreen.vue?vue&type=template&id=38d18a04&scoped=true&"
import script from "./WelcomeSecondScreen.vue?vue&type=script&lang=js&"
export * from "./WelcomeSecondScreen.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeSecondScreen.vue?vue&type=style&index=0&id=38d18a04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d18a04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDivider,VTextField})
